import { render, staticRenderFns } from "./simbase.vue?vue&type=template&id=5e1a4402&"
import script from "./simbase.vue?vue&type=script&lang=js&"
export * from "./simbase.vue?vue&type=script&lang=js&"
import style0 from "./simbase.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports